<template>
	<button
		:type="type"
		class="ov-btn"
		:class="[`ov-btn--${variant}`, `ov-btn--${size}`, { 'ov-btn--disabled': disabled }]"
		:disabled="disabled"
		@click="$emit('click', $event)"
	>
		<slot />
	</button>
</template>

<script>
export default {
	name: "OvButton",
	props: {
		variant: { type: String, default: "primary" },
		size: { type: String, default: "md" },
		type: { type: String, default: "button" },
		disabled: { type: Boolean, default: false },
	},
	emits: ["click"],
};
</script>

<style lang="scss" scoped>
.ov-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: var(--ds-space-2);
	font-family: inherit;
	font-weight: var(--ds-font-weight-medium);
	border: 1px solid transparent;
	border-radius: var(--ds-radius-md);
	cursor: pointer;
	transition: background 0.15s, color 0.15s, border-color 0.15s, box-shadow 0.15s;

	&--md {
		height: var(--ds-control-height);
		padding: 0 var(--ds-space-4);
		font-size: var(--ds-font-size-sm);
	}

	&--sm {
		height: var(--ds-control-height-sm);
		padding: 0 var(--ds-space-3);
		font-size: var(--ds-font-size-xs);

		.ov-busy-spinner {
			width: var(--ds-icon-size-md);
			height: var(--ds-icon-size-md);
		}
	}

	&--primary {
		background: var(--ds-color-primary);
		color: var(--ds-color-primary-text);

		&:hover:not(:disabled) {
			background: var(--ds-color-primary-hover);
		}
	}

	&--secondary {
		background: var(--ds-color-surface);
		color: var(--ds-color-text);
		border-color: var(--ds-color-border);

		&:hover:not(:disabled) {
			background: var(--ds-color-bg);
			border-color: #cbd5e1;
		}
	}

	&--ghost {
		background: transparent;
		color: var(--ds-color-text-muted);

		&:hover:not(:disabled) {
			background: var(--ds-color-bg);
			color: var(--ds-color-text);
		}
	}

	&--disabled,
	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
}
</style>
